import React, { Suspense } from 'react';
import debounce from 'lodash.debounce';
import { useObjectStore } from "../zustand/objects";
import { editorModalAccent, editorModalBorder } from "../styleFile";

export default function StoryboardTextField({ fieldType, isEditable, artboard, compact, dense }) {

  const { updateStoryboardFields, storyboardFields, viewportThemeOverride } = useObjectStore();
  const isDarkChrome = viewportThemeOverride === "dark";
  // const [value, setValue] = useState(storyboardFields[artboard][fieldType].toString());

  // Used debouncing to make sure we don't get 429 error when updaing api with new fieldvalue
  //   const handleChange = (event) => useCallback(debounce(() => {
  //   updateStoryboardFields(artboard, fieldType, event.target.value)
  // }, 500))
// console.log(storyboardFields[artboard].name.toString())
  const handleChange = debounce((e) => {
    updateStoryboardFields(artboard, fieldType, e.target.value)
  }, 500)

  //   const value = artboards[artboard].find(
  //     (x) => x.fieldType === fieldType
  //   ).fieldValue

  const minH = dense
    ? fieldType === "name"
      ? 24
      : 40
    : fieldType === "name"
      ? compact
        ? 38
        : 40
      : compact
        ? 56
        : 72;

  const pad = dense ? "4px 8px" : compact ? "7px 10px" : "8px 10px";
  const fz = dense ? 10 : 13;
  const rad = dense ? 4 : compact ? 6 : 8;
  const mb = dense ? 4 : compact ? 6 : 8;

  const fieldChrome = isDarkChrome
    ? {
        border: "#475569",
        bgEditable: "#1f2937",
        bgReadOnly: "#262626",
        color: dense ? "#D1D5DB" : "#E5E7EB",
      }
    : {
        border: editorModalBorder,
        bgEditable: "#ffffff",
        bgReadOnly: "#f9fafb",
        color: dense ? "#4b5563" : "#111827",
      };

  return (
    <form
      noValidate
      autoComplete="off"
      onChange={(e) => handleChange(e)}
      style={{ marginBottom: mb, marginRight: 0, paddingRight: 0 }}
    >
      <Suspense fallback={null}>
        <textarea
          style={{
            width: "100%",
            minHeight: minH,
            padding: pad,
            fontSize: fz,
            lineHeight: dense ? 1.4 : 1.45,
            borderRadius: rad,
            border: `1px solid ${fieldChrome.border}`,
            backgroundColor: isEditable ? fieldChrome.bgEditable : fieldChrome.bgReadOnly,
            color: fieldChrome.color,
            resize: "vertical",
            outline: "none",
            boxSizing: "border-box",
          }}
          onFocus={(e) => {
            if (isEditable) e.target.style.borderColor = editorModalAccent;
          }}
          onBlur={(e) => {
            e.target.style.borderColor = fieldChrome.border;
          }}
          type="text"
          defaultValue={storyboardFields[artboard][fieldType].toString()}
          placeholder={fieldType}
          disabled={!isEditable}
        />
        {/* <TextField
          // onKeyDown={ (event) => handleChange(event)}
          InputLabelProps={{ shrink: true }}
          defaultValue={storyboardFields[artboard][fieldType].toString()}
          id="outlined-multiline-flexible"
          label={fieldType}
          multiline
          maxRows={4}
          onChange={(e) => handleChange(e)}
          disabled={!isEditable}
          sx={{ p: 0 }}
          style={{ borderRadius: 0 }}
        /> */}
        </Suspense>
    </form>
  );
}